import './HotAssets.scss'
import {useQuery} from "@tanstack/react-query";
import {SEC} from "../../util/time-and-date.js";
import {getHotAssetsApi} from "../../api/statusApi.js";
import Asset from "./Asset.jsx";
import {useSelector} from "react-redux";
import {getAllAssets, getDustThreshold} from "../../ducks/assets-duck.js";
import {getIsNavExtended} from "../../ducks/user-duck.js";

export default () => {

    const assets = useSelector(getAllAssets)
    const dustThreshold = useSelector(getDustThreshold)
    const isNavExtended = useSelector(getIsNavExtended)

    const {data = [], isLoading} = useQuery({
        queryKey: ['hot-assets-api'],
        queryFn: getHotAssetsApi,
        refetchInterval: 2.5 * SEC,
    })
    const hotAssetsFiltered = filterHotAssets(data, assets, dustThreshold)

    return hotAssetsFiltered.length > 0 && !isLoading && (
        <div className={`hot-assets ${isNavExtended ? 'is-nav-extended' : ''}`}>
            <ul>
                {hotAssetsFiltered.map(asset =>
                    <Asset
                        key={asset.asset_id}
                        {...asset}
                    />
                )}
            </ul>
        </div>
    )
}

const filterHotAssets = (hotAssets, assets = [], threshold = 10) => {
    return hotAssets.filter(hotAsset => {
        const asset = assets.find(a => a.id === hotAsset.asset_id) || {value: 0}
        return asset.value > threshold
    })
}